import { sortBy, clone } from 'lodash';
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';
import Message from 'entities/Message';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'jsti... Remove this comment to see the full error message
import jstz from 'jstimezonedetect';

class Messages extends Collection<Message> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Message' is missing the following pro... Remove this comment to see the full error message
    this.model = Message;
  }

  // @ts-expect-error ts-migrate(2425) FIXME: Class 'Collection<Message>' defines instance membe... Remove this comment to see the full error message
  comparator(a: Message, b: Message): number {
    // $FlowFixMe these can be undefined, resulting in NaN for return value
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return b.getSeq() - a.getSeq();
  }

  getReverseArray() {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Message[] | undefined' is not assignable to ... Remove this comment to see the full error message
    const modelsCopy: any[] = clone(this.models);
    return sortBy<any>(modelsCopy, (message) => message.getSeq());
  }

  // XXX (rgoldfinger) remove when cleaning up old way of sending messages
  static yieldMessagesForGroupId(groupId: Backbone$Id, options: any = {}) {
    return apiRequest(`/classes/${groupId}/messages`, 'GET', options).then(_handleMessageResponse);
  }

  static yieldThreadMessagesForGroupId(
    groupId: Backbone$Id,
    threadUuid: string,
    options: any = {}
  ) {
    return apiRequest(`/classes/${groupId}/threads/${threadUuid}/messages`, 'GET', options).then(
      _handleMessageResponse
    );
  }

  static yieldScheduledThreadMessagesForGroupId(
    groupId: Backbone$Id,
    threadUuid: string,
    options: any = {}
  ) {
    return apiRequest(
      `/classes/${groupId}/threads/${threadUuid}/messages/scheduled`,
      'GET',
      options
    ).then(_handleMessageResponse);
  }

  // DELETEME not used
  // $FlowFixMe missing annotation
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'groupIds' implicitly has an 'any' type.
  static export(groupIds, since, until) {
    const tz = jstz.determine();
    const timezone = tz.name();

    return apiRequest('/messages/export', 'POST', {
      group_ids: groupIds,
      since,
      until,
      time_zone: timezone,
    });
  }
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
function _handleMessageResponse(response) {
  const messages = new Messages();
  if (response.messages) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'messageJSON' implicitly has an 'any' ty... Remove this comment to see the full error message
    response.messages.forEach((messageJSON) => {
      messages.add(Message.fromJSON(messageJSON));
    });
  }
  return messages;
}

export default Messages;
